import React, {useEffect, useState} from 'react';
import DefaultModal from "../../invoice/DefaultModal";
import Table from "../../../components/Table/Table";
import {request} from "../../../helper/APIUtils";
import {showAxiosError} from "../../../helper/helper";
import Alert from "react-s-alert";

const AdditionalServicesModal = (props) => {
    const {isOpen, closeModal, customer, currentUser} = props;
    const [additionalServicesData, setAdditionalServicesData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [userAdditionalServices, setUserAdditionalServices] = useState([]);
    const [user, setUser] = useState(null);
    const [userCurrentServices, setUserCurrentServices] = useState([]);
    const [additionalServices, setAdditionalServices] = useState([]);

    useEffect(() => {
        console.log("Açılış", customer, currentUser);
        fetchDataAdditionalService();
    }, []);

    const save = () => {
        if (userAdditionalServices.length > 0) {
            // const dataList = [];
            // for (let i = 0; i < userAdditionalServices.length; i++){
            //     if (userCurrentServices.filter((f) => userAdditionalServices[i].recordId))
            // }
            const data = {
                recordId: null,
                userAdditionalServices: userAdditionalServices,
                user: customer.recordId,
                createdAt: null,
                updatedAt: null,
            }
            let params = {
                url: '/userAdditionalServices/save',
                method: 'post',
                data: data
            }
            request(params).then((response) => {
                console.log("ResponseSave", response)
                Alert.success("Ek hizmet başarılı bir şekilde eklendi.", {
                    position: 'top-right',
                    effect: 'stackslide',
                    timeout: 1500,
                    html: false
                });
            }).catch((err) => {
                showAxiosError(err);
            })
        } else {
            Alert.error("Lütfen ek hizmet seçiniz!", {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 1500,
                html: false
            });
        }
    }

    const onSelectService = (row, e) => {
        console.log("Row", row, e.target.checked, userCurrentServices)
        let selectedService = row;
        let checkService = e.target.checked
        let additionalServicesTemp = [...additionalServices];
        // let userAdditionalService = {
        //     recordId: userCurrentServices?.filter((f) => f.additionalServices.recordId === selectedService.recordId).length > 0 ? userCurrentServices?.filter((f) => f.additionalServices.recordId === selectedService.recordId)[0].recordId : null,
        //     user: user,
        //     additionalServices: selectedService,
        //     createdAt: null,
        //     updatedAt: null
        // }


        if (checkService) {
            additionalServicesTemp.push(selectedService);
            setAdditionalServices(additionalServicesTemp);
            // userCurrentServices.push(userAdditionalService);
        } else {
            // const indexToRemove = userCurrentServices.findIndex(service => service.additionalServices.recordId === selectedService.recordId);
            const indexToRemove = additionalServices.findIndex(service => service === selectedService);
            if (indexToRemove !== -1) {
                userCurrentServices.splice(indexToRemove, 1);
                additionalServicesTemp.splice(indexToRemove, 1);
                setAdditionalServices(additionalServicesTemp);
            }
        }

        // isSelected(row);
    }

    const fetchDataAdditionalService = () => {
        setLoading(true);
        let params = {
            url: '/additionalServices/getAll',
            method: 'get'
        }
        request(params).then((response) => {
            setAdditionalServicesData(response.data)
            setLoading(false)
        }).catch((err) => {
            showAxiosError(err);
            setLoading(false)
        })

        let userParams = {
            url: `/userAdditionalServices/getUser/${customer.recordId}`,
            method: 'get'
        }
        request(userParams).then((response) => {
            setUser(response.data)
        })

        let paramsUserAdditionalService = {
            url: `/userAdditionalServices/getOne/${customer.recordId}`,
            method: 'get'
        }
        request(paramsUserAdditionalService).then((response) => {
            console.log("ResponseUserService", response)
            setUserCurrentServices(response.data)
        })
    }

    const isSelected = (item) => {
        // debugger

        // let aaa = userCurrentServices.some((service) => service.additionalServices.recordId === id);
        let aaa = additionalServices.indexOf(item) !== -1;
        console.log("ulala",aaa)
        return aaa;
    }

    const columnsAdditionalServices = [
        {
            accessor: "recordId",
            selectType: "checkbox",
            sortable: false,
            Cell: row => (
                <input type="checkbox"
                       checked={isSelected(row)}
                       onChange={(e) => onSelectService(row, e)}/>
            )
        },
        {
            Header: "Ek Hizmet",
            accessor: "ublCode",
            sortable: false,
            Cell: (row) => (
                <div>{row.ublCode}</div>
            )
        }
    ]
    return (console.log(userCurrentServices),
            <DefaultModal title="Ek Hizmetler"
                          size="md"
                          cancelBtnText="Kapat"
                          confirmBtnText="Kaydet"
                          onCancel={closeModal}
                          onConfirm={save}
                          isOpen={isOpen}
            >
                <div>
                    <Table columns={columnsAdditionalServices}
                           loading={loading}
                           content={additionalServicesData}
                           loadingText="Kayıtlar Getiriliyor..."
                           fetchData={fetchDataAdditionalService}
                           paginationEnabled={false}
                    />
                </div>
            </DefaultModal>
    )
}

export default AdditionalServicesModal;

// import React, { Component } from 'react';
// import DefaultModal from "../../invoice/DefaultModal";
// import Table from "../../../components/Table/Table";
// import { request } from "../../../helper/APIUtils";
// import { showAxiosError } from "../../../helper/helper";
// import Alert from "react-s-alert";
//
// class AdditionalServicesModal extends Component {
//     constructor(props) {
//         super(props);
//         this.state = {
//             additionalServicesData: [],
//             loading: false,
//             userAdditionalServices: [],
//             user: null,
//             userCurrentServices: [],
//         };
//     }
//
//     componentDidMount() {
//         console.log("Açılış", this.props.customer, this.props.currentUser);
//     }
//
//     save = () => {
//         // save function implementation
//     }
//
//     onSelectService = (row, e) => {
//         // onSelectService function implementation
//         let selectedService = row;
//         let checkService = e.target.checked
//         let userAdditionalService = {
//             recordId: this.state.userCurrentServices?.filter((f) => f.additionalServices.recordId === selectedService.recordId).length > 0 ? this.state.userCurrentServices?.filter((f) => f.additionalServices.recordId === selectedService.recordId)[0].recordId : null,
//             user: this.state.user,
//             additionalServices: selectedService,
//             createdAt: null,
//             updatedAt: null
//         }
//         if (checkService) {
//             this.state.userCurrentServices.push(userAdditionalService);
//         } else {
//             const indexToRemove = this.state.userCurrentServices.findIndex(service => service.additionalServices.recordId === selectedService.recordId);
//             if (indexToRemove !== -1) {
//                 this.state.userCurrentServices.splice(indexToRemove, 1);
//             }
//         }
//     }
//
//     fetchDataAdditionalService = () => {
//         this.setState({loading: true})
//         let params = {
//             url: '/additionalServices/getAll',
//             method: 'get'
//         }
//         request(params).then((response) => {
//             this.setState({loading: false, additionalServicesData: response.data})
//         }).catch((err) => {
//             showAxiosError(err);
//             this.setState({loading: false})
//         })
//         let userParams = {
//             url: `/userAdditionalServices/getUser/${this.props.customer.recordId}`,
//             method: 'get'
//         }
//         request(userParams).then((response) => {
//             this.setState({user: response.data})
//         })
//         let paramsUserAdditionalService = {
//             url: `/userAdditionalServices/getOne/${this.props.customer.recordId}`,
//             method: 'get'
//         }
//         request(paramsUserAdditionalService).then((response) => {
//             console.log("ResponseUserService", response)
//             this.setState({userCurrentServices: response.data})
//         })
//     }
//
//     isSelected = (id) => {
//         // isSelected function implementation
//         console.log("Ramazan", this.state.userCurrentServices.some((service) => service.additionalServices.recordId === id))
//         return this.state.userCurrentServices.some((service) => service.additionalServices.recordId === id);
//     }
//
//     render() {
//         console.log(this.state.userCurrentServices);
//         const columnsAdditionalServices = [
//             // columnsAdditionalServices array content
//             {
//                 header: "Ekle",
//                 accessor: "recordId",
//                 selectType: "checkbox",
//                 sortable: false,
//                 Cell: row => (
//                     <input type="checkbox"
//                            checked={this.isSelected(row.recordId)}
//                         // defaultChecked={isSelected(row.recordId)}
//                            onChange={(e) => this.onSelectService(row, e)}/>
//                 )
//             },
//             {
//                 Header: "Ek Hizmet",
//                 accessor: "ublCode",
//                 sortable: false,
//                 Cell: (row) => (
//                     <div>{row.ublCode}</div>
//                 )
//             }
//         ];
//
//         return (
//             <DefaultModal title="Ek Hizmetler"
//                           size="md"
//                           cancelBtnText="Kapat"
//                           confirmBtnText="Kaydet"
//                           onCancel={this.props.closeModal}
//                           onConfirm={this.save}
//                           isOpen={this.props.isOpen}
//             >
//                 <div>
//                     <Table columns={columnsAdditionalServices}
//                            loading={this.state.loading}
//                            content={this.state.additionalServicesData}
//                            loadingText="Kayıtlar Getiriliyor..."
//                            fetchData={this.fetchDataAdditionalService}
//                            paginationEnabled={false}
//                     />
//                 </div>
//             </DefaultModal>
//         );
//     }
// }
//
// export default AdditionalServicesModal;